import { createContext, useContext, type ReactNode } from "react";
import type { VenuePanel } from "./ProviderOutletContext";

export interface ProviderWorkspaceFormValue {
  operationsVersion: number;
  setOperationsVersion: (value: number | ((previous: number) => number)) => void;
  createBookingRequestToken: number;
  setCreateBookingRequestToken: (value: number | ((previous: number) => number)) => void;
  pendingReviewToken: number;
  setPendingReviewToken: (value: number | ((previous: number) => number)) => void;
  checkoutSessionId: string | null;
  setCheckoutSessionId: (value: string | null) => void;
  venuePanel: VenuePanel | null;
  setVenuePanel: (panel: VenuePanel | null) => void;
  venueRemovalNote: string;
  setVenueRemovalNote: (value: string) => void;
  venueRemovalError: string | null;
  setVenueRemovalError: (value: string | null) => void;
}

const ProviderWorkspaceFormContext = createContext<ProviderWorkspaceFormValue | null>(null);

export function ProviderWorkspaceFormProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: ProviderWorkspaceFormValue;
}) {
  return (
    <ProviderWorkspaceFormContext.Provider value={value}>
      {children}
    </ProviderWorkspaceFormContext.Provider>
  );
}

export function useProviderWorkspaceForm(): ProviderWorkspaceFormValue {
  const context = useContext(ProviderWorkspaceFormContext);
  if (!context) {
    throw new Error(
      "useProviderWorkspaceForm must be used within a ProviderWorkspaceFormProvider",
    );
  }
  return context;
}
